import * as React from "react";
import { useState } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { FormSubmit, Select, Spinner } from "components/common";
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row, Input } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
const getNotificationPlugin = (type) => {
  if (type === void 0) {
    return void 0;
  }
  return PluginStore.exports("eventNotificationTypes").find((n) => n.type === type);
};
const formattedEventNotificationTypes = () => PluginStore.exports("eventNotificationTypes").map((type) => ({ label: type.displayName, value: type.type }));
const EventNotificationForm = ({
  action = "edit",
  embedded,
  formId = void 0,
  notification,
  onCancel,
  validation,
  testResult,
  onSubmit,
  onChange,
  onTest
}) => {
  var _a, _b, _c, _d, _e, _f;
  const sendTelemetry = useSendTelemetry();
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  const handleSubmit = (event) => {
    sendTelemetry(
      action === "create" ? TELEMETRY_EVENT_TYPE.NOTIFICATIONS.CREATE_CLICKED : TELEMETRY_EVENT_TYPE.NOTIFICATIONS.EDIT_CLICKED,
      {
        app_section: "event-notification",
        app_action_value: `${action}-button`
      }
    );
    event.preventDefault();
    onSubmit(notification);
  };
  const handleChange = (event) => {
    const { name } = event.target;
    onChange(name, getValueFromInput(event.target));
  };
  const handleConfigChange = (nextConfig) => {
    onChange("config", nextConfig);
  };
  const handleEntityShareChange = (entityShare) => {
    onChange("share_request", entityShare);
  };
  const handleTypeChange = (nextType) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.NOTIFICATION_TYPE_SELECTED, {
      app_section: "event-definition-notifications",
      app_action_value: "notification-type-select",
      notification_type: nextType
    });
    const notificationPlugin2 = getNotificationPlugin(nextType);
    const defaultConfig = (notificationPlugin2 == null ? void 0 : notificationPlugin2.defaultConfig) || {};
    handleConfigChange({ ...defaultConfig, type: nextType });
  };
  const handleTestTrigger = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.NOTIFICATIONS.EXECUTE_TEST_CLICKED, {
      app_section: "event-notification",
      app_action_value: "execute-test-button"
    });
    onTest(notification);
  };
  const notificationPlugin = getNotificationPlugin(notification.config.type);
  const notificationFormComponent = (notificationPlugin == null ? void 0 : notificationPlugin.formComponent) ? React.createElement(notificationPlugin.formComponent, {
    config: notification.config,
    onChange: handleConfigChange,
    validation,
    setIsSubmitEnabled
  }) : null;
  const isNew = action === "create";
  const testButtonText = testResult.isLoading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Testing..." }) : "Execute Test Notification";
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { lg: 8 }, /* @__PURE__ */ React.createElement("form", { onSubmit: handleSubmit, id: formId }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "notification-title",
      name: "title",
      label: "Title",
      type: "text",
      bsStyle: validation.errors.title ? "error" : null,
      help: (_c = (_b = (_a = validation == null ? void 0 : validation.errors) == null ? void 0 : _a.title) == null ? void 0 : _b[0]) != null ? _c : "Title to identify this Notification.",
      value: notification.title,
      onChange: handleChange,
      required: true,
      autoFocus: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "notification-description",
      name: "description",
      label: /* @__PURE__ */ React.createElement("span", null, "Description ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
      type: "textarea",
      help: "Longer description for this Notification.",
      value: notification.description,
      onChange: handleChange,
      rows: 2
    }
  ), /* @__PURE__ */ React.createElement(FormGroup, { controlId: "notification-type", validationState: validation.errors.config ? "error" : null }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Notification Type"), /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "notification-type",
      options: formattedEventNotificationTypes(),
      value: notification.config.type,
      onChange: handleTypeChange,
      clearable: false,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, (_f = (_e = (_d = validation == null ? void 0 : validation.errors) == null ? void 0 : _d.config) == null ? void 0 : _e[0]) != null ? _f : "Choose the type of Notification to create.")), notificationFormComponent, notificationFormComponent && /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "Test Notification ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")), /* @__PURE__ */ React.createElement(FormControl.Static, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "small", disabled: testResult.isLoading, onClick: handleTestTrigger }, testButtonText)), testResult.message && /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: testResult.error ? "danger" : "success",
      title: testResult.error ? "Error: " : "Success: "
    },
    testResult.message
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Execute this Notification with a test Alert.")), isNew && /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: "Search for a User or Team to add as collaborator on this notification.",
      entityType: "notification",
      entityTitle: "",
      onSetEntityShare: handleEntityShareChange
    }
  ), !embedded && /* @__PURE__ */ React.createElement(
    FormSubmit,
    {
      disabledSubmit: !isSubmitEnabled,
      submitButtonText: `${isNew ? "Create" : "Update"} notification`,
      onCancel
    }
  ))));
};
export default EventNotificationForm;
